import script from "./ModalFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFrame.vue?vue&type=script&setup=true&lang=js"

import "./ModalFrame.vue?vue&type=style&index=0&id=2c0809c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c0809c8"]])

export default __exports__